import { html, LitElement, TemplateResult } from 'lit'
import { customElement, property } from 'lit/decorators.js'
import { FILTER_WIZARD_STORE, FilterWizardStore } from 'components/discovery/filter-wizard/filter-wizard-store.js'
import { AttributeValue } from 'components/discovery/shared/search/typing/filter-attributes.js'
import { inject } from '@cloudsuite/mosaic-shared/scripts/dependency-injection.js'

@customElement('csc-attribute-value-name')
export class CSCAttributeValueName extends LitElement {
  @inject(FILTER_WIZARD_STORE)
  private filterWizardStore!: FilterWizardStore

  @property({ type: Object, attribute: 'attribute-value' })
  attributeValue!: AttributeValue

  override connectedCallback() {
    super.connectedCallback()
    this.setAttribute('id', `attribute-value-${this.attributeValue.id}`)
  }

  private optionClicked() {
    if (this.attributeValue.disabled) return

    this.filterWizardStore.search(this.attributeValue)
    this.attributeValue.selected = !this.attributeValue.selected
    this.requestUpdate()
  }

  private selectableState() {
    if (this.attributeValue.disabled) return 'disabled'
    return this.attributeValue.selected ? 'selected' : 'selectable'
  }

  override render(): TemplateResult {
    return html`
      <cse-selectable
        state="${this.selectableState()}"
        @click="${this.optionClicked}"
      >
        <cse-text class="title" variant="body-s">
          ${this.attributeValue.name}
        </cse-text>
      </cse-selectable>
    `
  }
}
